<div class="card-body">
    <div class="det-details">
            <div class="ibox-title report_flexweb">
                <div>
                    <h5>BuildigList</h5>
                </div>
                <div>
                    <figure>
                        <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                    </figure>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <hr class="line">
         
            <div class="box2">
                <div>
                    <div class="campus_dtl">
                        <h3 class="course" style="font-weight: bold;">buildingName</h3>
                        <h3 class="name1" style="font-weight: bold;">fusionBuildingCodeProd</h3>
                    </div>
                    <div>
                        <div class="campus_dtl" *ngFor="let item of buildingList">
                            <h3 class="course">{{item.buildingName}}</h3>
                            <h3 class="name1">{{item.fusionBuildingCodeProd}}</h3>
                        </div>
                       

                    </div>

                </div>
            </div>
      
    </div>
